import { render } from "./ClientServices.vue?vue&type=template&id=cb064862"
import script from "./ClientServices.vue?vue&type=script&lang=js"
export * from "./ClientServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__